module.exports = __webpack_public_path__ + "static/media/home-white.5581852c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home-white.svg
// module id = 207
// module chunks = 0